/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Campaign Info modal activate styles
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import styled from 'styled-components';

export const CampaignInfoModalActivateStyled = styled.div.attrs({
    className: 'modal-campaign-info',
})`
    .modal-campaign-info__text:not(:last-of-type) {
        margin-bottom: 16px;
    }
`;
